import axios from 'axios';
import config from 'config.js';

// Constants
const GET_STATISTICS_REQUEST = 'dashboard/GET_STATISTICS_REQUEST';
const GET_STATISTICS_SUCCESS = 'dashboard/GET_STATISTICS_SUCCESS';
const GET_STATISTICS_FAILURE = 'dashboard/GET_STATISTICS_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  statistics: null,

  getStatistics: { ...endpoitInitialStatus },
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  if (action.type === GET_STATISTICS_REQUEST) {
    state.getStatistics = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_STATISTICS_SUCCESS) {
    state.getStatistics = getEndpointStatus('success');
    state.statistics = action.payload;

    return { ...state };
  }

  if (action.type === GET_STATISTICS_FAILURE) {
    state.getStatistics = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function getStatistics() {
  const request = () => { return { type: GET_STATISTICS_REQUEST } };
  const success = (res) => { return { type: GET_STATISTICS_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_STATISTICS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getStatistics();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

const services = {
  getStatistics: async (data) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/statistics`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        data
      });

      return response;
    } catch (e) {
      return e.response;
    }
  }
};
